import React from 'react'
import styled from '@emotion/styled'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { color } from 'styled-system'

import styles from './styles.scss'

const Basic = ({ className }) => <div className={className} />
const Dot = styled(Basic)`
  ${color}
`

const LoadingBubbles = props => {
  const { color, style } = props

  return (
    <span className={styles.root} style={style}>
      <Dot className={classnames(styles.bounce, styles.bounce1)} backgroundColor={color} />
      <Dot className={classnames(styles.bounce, styles.bounce2)} backgroundColor={color} />
      <Dot className={classnames(styles.bounce, styles.bounce3)} backgroundColor={color} />
    </span>
  )
}

LoadingBubbles.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
}

LoadingBubbles.defaultProps = {
  color: '#e78d2d',
  style: {},
}

export default LoadingBubbles
